import React from "react";
import { PaymentActionsContext, PaymentRootScreenContext } from "./context";

export const usePaymentActionsContextProvider = () => {
  const context = React.useContext(PaymentActionsContext);
  return context;
};

export const usePaymentRootScreenContextProvider = () => {
  const context = React.useContext(PaymentRootScreenContext);
  if (!context) {
    throw new Error("No PaymentRootScreenContext context was provided.");
  }
  return context;
};
